import { userActionTypes, designActionTypes } from '../actions/types';
import { userService } from '../services';
import { storeUser } from '../utils/authStorage';
export const userActions = {
  login,
  logout,
  register,
  getAll,
  update,
  delete: _delete,
  authenticate,
  confirmMobile,
  resendConfirmationSMS,
  forgotPassword,
  resetPassword,
  resetState,
  changeProfilePicture,
  changeTheme,
  setToken,
};

function resetState() {
  return dispatch => dispatch({ type: userActionTypes.RESET_STATE });
}

function login(username, password) {
  return dispatch => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      user => {
        dispatch(success(user));
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request(user) {
    return { type: userActionTypes.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userActionTypes.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userActionTypes.LOGIN_FAILURE, error };
  }
}

function logout() {
  return async (dispatch, getState) => {
    const { loggingOut } = getState().authentication;

    if (!loggingOut) {
      try {
        dispatch({ type: userActionTypes.LOGOUT_REQUEST });
        await userService.logout();
        dispatch({ type: designActionTypes.RESET_STATE });
        return dispatch({ type: userActionTypes.LOGOUT });
      } catch (error) {
        return dispatch({ type: userActionTypes.LOGOUT_FAILURE });
      }
    }
  };
}

function register(user) {
  return dispatch => {
    dispatch(request(user));

    userService.register(user).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request(user) {
    return { type: userActionTypes.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userActionTypes.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userActionTypes.REGISTER_FAILURE, error };
  }
}

function confirmMobile(props) {
  return dispatch => {
    dispatch(request());

    userService.confirmMobile(props).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userActionTypes.CONFIRM_MOBILE_REQUEST };
  }
  function success() {
    return { type: userActionTypes.CONFIRM_MOBILE_SUCCESS };
  }
  function failure(error) {
    return { type: userActionTypes.CONFIRM_MOBILE_FAILURE, error };
  }
}

function resendConfirmationSMS(props) {
  return dispatch => {
    dispatch(request());

    props.resend = true;

    userService.resendConfirmationSMS(props).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userActionTypes.RESEND_CONFIRMATION_SMS_REQUEST };
  }
  function success() {
    return { type: userActionTypes.RESEND_CONFIRMATION_SMS_SUCCESS };
  }
  function failure(error) {
    return { type: userActionTypes.RESEND_CONFIRMATION_SMS_FAILURE, error };
  }
}

function forgotPassword(props) {
  return dispatch => {
    dispatch(request());

    userService.forgotPassword(props).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userActionTypes.FORGOT_PASSWORD_REQUEST };
  }
  function success() {
    return { type: userActionTypes.FORGOT_PASSWORD_SUCCESS };
  }
  function failure(error) {
    return { type: userActionTypes.FORGOT_PASSWORD_FAILURE, error };
  }
}

function resetPassword(props) {
  return dispatch => {
    dispatch(request());

    userService.resetPassword(props).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: userActionTypes.RESET_PASSWORD_REQUEST };
  }
  function success() {
    return { type: userActionTypes.RESET_PASSWORD_SUCCESS };
  }
  function failure(error) {
    return { type: userActionTypes.RESET_PASSWORD_FAILURE, error };
  }
}

function getAll() {
  return (dispatch, getState) => {
    dispatch(request());

    userService.getAll().then(
      users => dispatch(success(users)),
      error => dispatch(failure(error, getState().authentication.pendingRefreshingToken)),
    );
  };

  function request() {
    return { type: userActionTypes.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userActionTypes.GETALL_SUCCESS, users };
  }
  function failure(error, pendingRefreshToken) {
    if (error.code === 'invalidToken') {
      if (pendingRefreshToken) {
        return {
          type: userActionTypes.PENDING_REFRESH_TOKEN,
          error: error.error,
        };
      } else {
        return { type: userActionTypes.INVALID_TOKEN, error: error.error };
      }
    } else {
      return { type: userActionTypes.GETALL_FAILURE, error: error.error };
    }
  }
}

function update(user) {
  return (dispatch, getState) => {
    dispatch(request());

    user.details.nationalId = user.details.nationalId || null;
    user.details.mobile = user.details.mobile || null;
    user.details.email = user.details.email || null;

    userService.update(user).then(
      user => {
        dispatch(success());
        dispatch({ type: userActionTypes.UPDATE_USER, user }); // For update user in authentication state
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            userActionTypes.UPDATE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: userActionTypes.UPDATE_REQUEST };
  }
  function success() {
    return { type: userActionTypes.UPDATE_SUCCESS };
  }
}

function changeProfilePicture(files) {
  return (dispatch, getState) => {
    dispatch(request());

    const user = getState().authentication.user;
    let userId = null;
    if (user.role === 'client') {
      userId = user.userId;
    }

    userService.changeAvatar(userId, files).then(
      resource => {
        dispatch(success(resource));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            userActionTypes.CHANGE_PROFILE_PICTURE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: userActionTypes.CHANGE_PROFILE_PICTURE_REQUEST };
  }
  function success(resource) {
    return { type: userActionTypes.CHANGE_PROFILE_PICTURE_SUCCESS, resource };
  }
}

function changeTheme(theme) {
  return (dispatch, getState) => {
    dispatch(request());

    let userId = getState().authentication.user.userId;

    userService.update({ userId, theme }).then(
      user => {
        dispatch(success());
        dispatch({ type: userActionTypes.UPDATE_USER, user }); // For update user in authentication state
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            userActionTypes.UPDATE_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: userActionTypes.UPDATE_REQUEST };
  }
  function success() {
    return { type: userActionTypes.UPDATE_SUCCESS };
  }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    userService.delete(id).then(
      () => {
        dispatch(success(id));
      },
      error => {
        dispatch(failure(id, error));
      },
    );
  };

  function request(id) {
    return { type: userActionTypes.DELETE_REQUEST, id };
  }
  function success(id) {
    return { type: userActionTypes.DELETE_SUCCESS, id };
  }
  function failure(id, error) {
    return { type: userActionTypes.DELETE_FAILURE, id, error };
  }
}

function authenticate({ password }) {
  return (dispatch, getState) => {
    dispatch(request());

    userService.authenticate(password).then(
      () => {
        dispatch(success());
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            userActionTypes.AUTHENTICAT_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: userActionTypes.AUTHENTICAT_REQUEST };
  }
  function success() {
    return { type: userActionTypes.AUTHENTICAT_SUCCESS };
  }
}

function setToken(props) {
  var user = { 
    role: 'client',
    success: true,
    theme: 'dark',
    isExportSession: true,
    userId: '5eb6a641d7b4891227d5444b',
    // username: '09370117629',
    ...props 
  };
  storeUser(user);
  return dispatch => dispatch({ type: userActionTypes.LOGIN_SUCCESS, user });
}

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error };
  }
};
